<template>
  <div class="parties-of-lawsuit-list text-right">
    <div class="section-header">
      <h2 class="section-title">
        {{ sectionTitle }} ({{ Object.keys(data).length }})
      </h2>
      <div
        v-if="!mode.isViewMode && !disabled && showAddDefendant"
        class="actions"
      >
        <naj-button
          outlined
          @click="$emit('addCaseParty')"
        >
          {{ local.common.addOriginalParty }}
        </naj-button>
      </div>
    </div>

    <template v-for="value in sortedData">
      <case-party-card
        :key="value.objectKey"
        :disabled="disabled||value.isAudited"
        :other-parties-side="isCurrentUserFromOtherCasePartiesSide"
        :data="value"
        :parties-list="sortedData"
        @viewAttorney="openAttorneyModal"
      ></case-party-card>
    </template>
    <attorney-modal
      v-if="attorneyData.attorneyCode"
      ref="viewAttorneyModal"
      :attorney-type="attorneyData.attorneyTypeId"
      :attorney-code="attorneyData.attorneyCode.toString()"
      :agent-social-id="attorneyData.agentSocialId"
      :client-social-id="attorneyData.clientSocialId"
      @onClose="onModalClose"
    ></attorney-modal>
  </div>
</template>

<script>
import CasePartyCard from './case-party-card';
import AttorneyModal from '@/modules/lawsuit/components/attorney-modal';
import { casePartyRoleEnum } from '@/helpers/enum.js';

import { createNamespacedHelpers } from 'vuex';
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('LawsuitModule');
const { mapGetters: mapGlobalGetters } = createNamespacedHelpers('GlobalModule');

const initAttorneyData = () => ({
  attorneyCode: 0,
  agentSocialId: '',
  clientSocialId: '',
  attorneyTypeId: 1,
});

export default {
  inject: ['mode'],
  components: {
    CasePartyCard,
    AttorneyModal,
  },
  props: ['sectionTitle', 'data', 'type'],
  data() {
    return {
      attorneyText: null,
      attorneyData: initAttorneyData(),
      casePartyRoleEnum: casePartyRoleEnum,
      sortedData: [] 
    };
  },
  computed: {
    ...mapState({
      auditFields: state => state.lawsuitRequest.auditFields,
      partyAttributesBasicInfo: state => state.partyAttributesBasicInfo
     }),
    ...mapGetters([
      'isCurrentUserExistsInProsecutorsList',
      'isCurrentUserExistsInDefendantsList',
      'selectedCaseType',
    ]),
    ...mapGlobalGetters(['socialId']),
    disabled() {
      if (this.type === casePartyRoleEnum.prosecutor && this.auditFields.isProsecutorListAudited) {
        return true;
      }

      if (this.type === casePartyRoleEnum.defendant && this.auditFields.isDefendantListAudited) {
        return true;
      }

      return false;
    },
    isCurrentUserFromOtherCasePartiesSide() {
      return (this.type === casePartyRoleEnum.prosecutor && this.isCurrentUserExistsInDefendantsList)
        || (this.type === casePartyRoleEnum.defendant && this.isCurrentUserExistsInProsecutorsList);
    },
    showAddDefendant() {
      if (this.type === casePartyRoleEnum.defendant) {
        return this.selectedCaseType && !this.selectedCaseType.mustHaveNoDefendant;
      }
      return true;
    },
  },
  watch: {
    data: {
      handler() {
        if (this.partyAttributesBasicInfo?.length) {
          this.sortCaseParties();
        }
      },
      deep: true,
    },
  },
  created() {
    this.getPartyAttributesBasicInfo().then(() => {
      this.sortCaseParties();
    });
  },
  methods: {
    ...mapActions({
      getPartyAttributesBasicInfo: 'getPartyAttributesBasicInfo',
    }),
    openAttorneyModal({ attorneyCode, agentSocialId, clientSocialId, attorneyTypeId }) {
      this.attorneyData = {
        attorneyCode,
        agentSocialId,
        clientSocialId,
        attorneyTypeId,
      };
      this.$nextTick(() => {
        this.$refs.viewAttorneyModal.show();
      });
    },
    onModalClose() {
      this.attorneyData = initAttorneyData();
    },
    sortCaseParties() {
      if (!this.data || !Object.keys(this.data).length) {
        this.sortedData = [];
        return;
      }
      const caseTypeId = this.selectedCaseType?.id;
      this.sortedData = Object.values(this.data).sort((a, b) => {
        const orderA = this.getSequenceOrder(caseTypeId, a.subPartyRoleId);
        const orderB = this.getSequenceOrder(caseTypeId, b.subPartyRoleId);
        if (orderA == null && orderB == null) return 0;
        if (orderA == null) return 1;
        if (orderB == null) return -1;
        return orderA - orderB;
      });
    },
  
    getSequenceOrder(caseTypeId, subPartyRoleId) {
      if (!caseTypeId || !subPartyRoleId || !this.partyAttributesBasicInfo) return null;
      const attr = this.partyAttributesBasicInfo.find(
        item => item.caseTypeId === caseTypeId && item.partyRoleId === subPartyRoleId
      );
      return attr?.sequenceOrder ?? null;
    }
  },
};
</script>

<style lang="scss" scoped>
.section-header {
  display: flex;
  justify-content: space-between;
  padding: 18px;
  border: 2px solid #f1f1f2;
  border-bottom: 0;
  .section-title {
    font-weight: bold;
    display: inline-block;
    position: relative;
    margin: 0;
    font-size: 16px;
    color: #034f45;
  }
}
.attorney-text {
  font-size: 18px;
  line-height: 1.8;
  color: #6d6d6d;
}
</style>
